import React, { useEffect, useState } from "react";
import { AlertTriangle, Pencil } from "lucide-react";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../ui/dialog";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";

export const InvoiceEditReasonDialog = ({ invoice, onOpenChange, onConfirm }) => {
  const [reason, setReason] = useState("");
  useEffect(() => { if (invoice) setReason(""); }, [invoice]);
  if (!invoice) return null;
  const ready = reason.trim().length >= 3;
  return (
    <Dialog open={!!invoice} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="invoice-edit-reason-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><AlertTriangle className="h-5 w-5 text-amber-600" />Edit {invoice.status === "paid" ? "paid" : "sent"} invoice {invoice.number}?</DialogTitle>
          <DialogDescription>
            The colony may already have the original PDF. Explain why this invoice needs a correction and confirm before editing. Saving will not resend it automatically.
          </DialogDescription>
        </DialogHeader>
        <div>
          <Label htmlFor="invoice-edit-reason">Why are you editing this invoice?</Label>
          <Textarea id="invoice-edit-reason" autoFocus rows={4} maxLength={500} value={reason} onChange={(event) => setReason(event.target.value)} placeholder="Example: The July chemical charge was entered twice." data-testid="invoice-edit-reason-input" />
          <div className="mt-1 text-right text-[11px] text-muted-foreground" data-testid="invoice-edit-reason-count">{reason.length}/500</div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="invoice-edit-reason-cancel">Cancel</Button>
          <Button onClick={() => onConfirm(reason.trim())} disabled={!ready} data-testid="invoice-edit-reason-confirm"><Pencil className="mr-2 h-4 w-4" />Yes, edit invoice</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};